import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";
import { ICreateTaskData } from "../types/CreateTask-interface";

export const fetchCreateTask = createAsyncThunk(
    'contract/fetchCreateTask',
    async ({ dataForm, saveAsDraft }: {
        dataForm: ICreateTaskData,
        saveAsDraft: boolean
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "ContractID": dataForm.ContractID,
                "ThemeID": dataForm.Themes,
                "AuthorsComment": dataForm.Comment,
                "AuthorsExpectedCompletionDate": dataForm.Date,
                "SaveAsDraft": saveAsDraft,
                "Files": dataForm.Files,
            };
            const response = await getRequest(requestBody, 'dms-hr', 'createTask', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { taskID: data.Task.ID, taskNumber: data.Task.Number, fetchTime: parseToTimestamp(new Date()) };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);